import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { EmployeesGraphicIconSvg } from '../../../../lib/icons';
import { Button } from '../../../../lib/components/atomic/button';

export const UpdateEmployeesStepThree: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      height="100%"
    >
      <EmployeesGraphicIconSvg />
      <Typography variant="subtitle1" fontSize="1.5rem" color="heaven.main" marginTop="3rem">
        {t('common:CONGRATULATION')}
      </Typography>
      <Typography variant="subtitle1" color="secondary">
        {t('employee:EMPLOYEES_UPDATED')}
      </Typography>
      <Button onClick={() => navigate(`/employees`)} className="mt-8">
        {t('common:SHOW_EMPLOYEES')}
      </Button>
    </Box>
  );
};
